<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="pa-0"
          icon
          id="link-reply-template"
          v-track="'show-reply-template-list'"
          min-width="40px"
          @click="showDrawer()"
        >
          <v-icon> mdi-note-text-outline </v-icon>
        </v-btn>
      </template>
      <span> Reply Templates </span>
    </v-tooltip>

    <v-navigation-drawer
      v-model="replyTemplateDrawer"
      class="px-6 pt-6 overflow-hidden pr-2"
      :style="templateDrawerStyle"
      id="use-reply-template-drawer"
      width="550px"
      right
      fixed
      temporary
    >
      <div class="mb-5 fixed-drawer pr-8 pl-2">
        <v-row no-gutters>
          <v-col align="left" cols="auto">
            <h5
              class="
                text-h5
                font-weight-600
                float-left
                text-capitalize
              "
            >
              <span class="secondary--font"> Reply Templates </span>
            </h5>
          </v-col>
          <v-col align="right">
            <v-btn
              icon
              @click.stop="replyTemplateDrawer = false"
              class="float-right"
              v-track="'template-drawer-close-btn'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card elevation="0">
          <p class="mt-3">Select / insert reply template from below list</p>
          <v-form class="mt-0" v-model="valid" ref="">
            <v-card-text class="px-0">
              <v-text-field
                v-model="searchTemplate"
                placeholder="Search Template"
                class="text-field"
                v-track="'search-reply-template'"
                outlined
                required
                dense
                hide-details
                prepend-inner-icon="mdi-magnify"
                clearable
                :loading="isLoading"
                @click:clear="getTemplateList()"
                @input="applySearch(searchTemplate)"
              ></v-text-field>
            </v-card-text>
          </v-form>
        </v-card>

        <v-expansion-panels
          v-show="templateList.length"
          accordion
          class="elevation-0 mt-3 template-list"
        >
          <v-expansion-panel v-for="(item, index) in templateList" :key="index">
            <v-expansion-panel-header class="pl-1">
              <template v-slot:default="{}">
                <div class="justify-space-between d-flex">
                  <div
                    :class="
                      selectedIcon(item) ? 'grey--text text--darken-2' : ''
                    "
                  >
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="cursor-pointer"
                          right
                          v-bind="attrs"
                          v-on="on"
                          :color="selectedIcon(item) ? '#03b6fc' : ''"
                          @click.stop="getSelectedTemplate(item)"
                        >
                          <template v-if="!selectedIcon(item)">
                            mdi-radiobox-blank
                          </template>
                          <template v-else> mdi-radiobox-marked </template>
                        </v-icon>
                      </template>
                      <span>Select Template</span>
                    </v-tooltip>
                    <!-- <v-icon>
                      <template v-if="open">mdi-chevron-up</template>
                      <template v-else>mdi-chevron-down</template>
                    </v-icon> -->
                    <span class="ml-2 font-weight-medium">{{
                      item.name | upperCaseFirst
                    }}</span>
                  </div>
                </div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content color="#F0F0F0" class="pa-5">
              <div v-html="item.body"></div>
              <ShowAttachments :fileData="item" size="small"> </ShowAttachments>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <p v-if="templateList.length == 0">No templates found !</p>
      </div>

      <template v-slot:append>
        <div class="pa-2">
          <v-card-actions class="px-0 d-flex align-end">
            <v-btn
              id="cancel-drawer"
              class="font-weight-bold mb-4"
              v-track="'cancel-reply-template'"
              outlined
              @click.stop="cancelAction()"
              >Cancel</v-btn
            >

            <v-btn
              id="create-template"
              dense
              :dark="selectedTemplate !== null"
              :disabled="selectedTemplate == null"
              class="font-weight-bold mb-4"
              v-track="'add-reply-template'"
              @click="applyTemplate()"
              >Add</v-btn
            >
          </v-card-actions>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { $replytemplates } from "@/services/Index";
import ShowAttachments from "@/components/tickets/reply/ShowAttachments";

export default {
  props: {
    ticketData: {
      type:Object,
      default: ()=> ({})
    },
    templateDrawerStyle: {
      type: Object,
      default: ()=> ({})
    },
    parseTemplate: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    ShowAttachments,
  },
  data() {
    return {
      replyTemplateDrawer: false,
      valid: true,
      searchTemplate: "",
      templateList: [],
      pageNo: 1,
      isLoading: false,
      totalCount: null,
      selectedTemplate: null,
    };
  },

  methods: {
    showDrawer() {
      this.replyTemplateDrawer = true;
      this.getTemplateList(this.ticketData.id, "", "showDrawer");
    },

    getSelectedTemplate(data) {
      this.selectedTemplate = data;
    },

    selectedIcon(item) {
      let filledRadioButton = false;
      if (
        this.selectedTemplate &&
        this.selectedTemplate.name == item.name &&
        this.selectedTemplate.body == item.body
      ) {
        filledRadioButton = true;
      }
      return filledRadioButton;
    },

    applyTemplate() {
      if (this.selectedTemplate) {
        this.$emit("useTemplate", this.selectedTemplate);
        this.replyTemplateDrawer = false;
        this.selectedTemplate = null;
      }
    },

    cancelAction() {
      this.$emit("useTemplate", "");
      this.replyTemplateDrawer = false;
    },

    applySearch(val) {
      if (val) {
        this.pageNo = 1;
        this.getTemplateList(this.ticketData.id, val);
      }
    },

    async getTemplateList(id = this.ticketData.id, val = "", action = "") {
      this.isLoading = true;

      const data = {
        attachments: !this.parseTemplate,
        per_page: 10,
        page: this.pageNo,
        q: {
          name_cont: val,
          m: "or",
        },
      };

      try {
        this.selectedTemplate = null;
        const response = this.parseTemplate 
          ? await $replytemplates.parsedTemplates(id, data, {}) 
          : await $replytemplates.fetchList(data, {});

        if (response.data) {
          if (action === "scroll") {
            this.templateList = [...this.templateList, ...response.data.reply_templates];
          } else {
            this.templateList = response.data.reply_templates;
            if (action === "showDrawer") {
              this.addListener();
            }
          }
          this.totalCount = response.data.pagination.total_count;
        }
      } finally {
        this.isLoading = false;
      }
    },

    addListener() {
      let selectorClass = ".template-list";
      let el = document.querySelector(selectorClass);
      /** add scroll event **/
      if (el) {
        el.addEventListener("scroll", this.onScroll);
      }
    },

    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.templateList.length < this.totalCount) {
          this.pageNo = this.pageNo + 1;
          this.getTemplateList(this.ticketData.id, "", "scroll");
        }
      }
    },
  },
};
</script>

<style lang="scss">
#use-reply-template-drawer {
  .v-navigation-drawer__content {
    overflow: hidden !important;
  }
  .template-list {
    max-height: 400px !important;
    overflow: hidden;
    overflow-y: auto;
    padding-bottom: 120px;
  }
  .v-expansion-panel:before{
    box-shadow: none !important;
  }
  .v-expansion-panels > *:first-child {
    border-top-left-radius: initial !important;
    border-top-right-radius: initial !important;
    border-top: 1px solid #e1dede;
  }
  .v-expansion-panels > *:last-child {
    border-bottom: 1px solid #e1dede;
  }
  .v-expansion-panel-content {
    max-height: 180px;
    overflow-y: auto;
    display: block;
  }
}
</style>
